/*
    By default, this function simply grab any parameter from the url
    and save them into a hidden field which has same name ( and if there is one )
    and then save them into session object with prefix 'session.tracking.'

    However you can configure it by passsing a third object as option, see below comments
    for details.

    this module requires window.cookie, window.URI
*/
define('shared/util/dispatchers/DataDispatcher',[
    'shared/lib/RSVP', 
    './publisherFactory', 
    './retrieverFactory',
    'shared/lib/console'
], 
function( RSVP, publisherFactory, retrieverFactory, console ){
    'use strict';

    var TIMEOUT = 1000 * 60 * 5;
    var LOG_NAME = 'Data Dispatcher:';

    /* Privates */
    function getPublisherProcessor( key, value, cur, options ) {
        var me = this;
        return function processor( resolve, reject ) {
            var promises = [];

            for( var i = 0; i < cur.targets.length; i++ ) {

                var target = cur.targets[i];
                var publishingKeys = target.key || key;
                var publisher = publisherFactory.create( target );

                if (publisher == null) {
                    // no publisher? skip it
                    console.error(LOG_NAME, 'No publisher is found', target);
                    continue;
                }

                if ( typeof publishingKeys == 'string' ) {
                    publishingKeys = [ publishingKeys ];
                }

                for( var j = 0; j < publishingKeys.length ; j++ ) {
                    var publishingKey = publishingKeys[j];

                    var dfd = RSVP.defer();

                    promises.push( dfd.promise );

                    publisher
                        .call( me, publishingKey, value, target, options )
                        .then(dfd.resolve, dfd.reject);

                    // set a timeout just in case publishing stalled
                    (function(dfd){
                        setTimeout(function(){
                            dfd.reject('timed out');
                        }, options.timeout || TIMEOUT );
                    })(dfd);
                }
            }

            RSVP.all(promises)
                .then(resolve, reject);
        };
    }

    function getRetrievingProcessor( key, cur, options ) {
        var me = this;
        return function processor( resolve, reject ) {

            var i = 0;
            (function loop(){

                if ( i >= cur.sources.length ) {
                    reject('Value for ' + key + ' cannot be found');
                    return;
                }

                var source = cur.sources[i];
                var retrievingKey = source.key || key;
                var retriever = retrieverFactory.create( source );
                var dfd = RSVP.defer();
                var isResolved = false;

                dfd.promise
                .then(function(value){
                    return new RSVP.Promise( function( resolve, reject ){
                        if (value == undefined && !(source.allowUndefined === true) && !(cur.allowUndefined === true && (i + 1) >= cur.sources.length )) {
                            reject( 'DataDispatcher: Value for ' + key + ' cannot be found.' );
                        }
                        else {
                            resolve( value );
                        }
                    } );
                })
                .then(function( value ){
                    // if success, resolve with value
                    isResolved = true;
                    resolve( value );
                }, function(){
                    // otherwise, try next loop
                    i++;
                    loop();
                });

                if (retriever == null) {
                    // no retriever? skip it
                    var err = 'No retrieve is found';
                    console.error(LOG_NAME, err, source);
                    dfd.reject(err);
                    return;
                }

                // start aync retrieving 
                retriever.call( me, retrievingKey, source, options )
                    .then(dfd.resolve, dfd.reject);

                // set a timeout just in case retrieving stalled
                setTimeout(function(){
                    if (isResolved === true) {
                        return;
                    }
                    if (source.allowUndefined === true || cur.allowUndefined === true) {
                        console.log(LOG_NAME, retrievingKey + ' timed out.');
                        dfd.resolve(null);
                    }
                    else {
                        dfd.reject('timed out');
                    }
                }, options.timeout || TIMEOUT );


            })( /* start the loop */ );
        };
    }

    /* Publics */

    function Ctor( $el ){
        if ( $el == null || ($el.length >> 0) <= 0 ) {
            throw new Error('Please specify the targeting element.');
        }

        this.$el = $el;
    }

    /**
     * options - declaration of how to process url parameters
            items - an obj contains all settings.
                source - 
                    retrieve - a custom function to get the value
                    type - source type, can be omniture, cookie, query, state
                    key - specify in case the key for retrieving is different from item name
                    allowUndefined - undefined will be consider a valid value, default to false
                    doNotWait - true to skip the waiting for the value, default to false(means will wait)
                target - 
                    publish - a custom function to set the value to target
                    type - target type
                    key - the key to set on target

            timeout - the timeout, default to 5
     */
    Ctor.prototype.dispatch = function( options ){
        if ( options == null ) {
            throw new Error('no option specified.');
        }
        
        var me = this;

        var items = options.items;
        var cur, key, promise;
        var promises = [];

        for( key in items ) {
            if ( !items.hasOwnProperty( key ) ) {
                continue;
            }

            cur = items[key];

            if ( cur.sources == null || cur.targets == null ) {
                // oops
                continue;
            }

            (function(me, key, cur){
                promise = 
                    new RSVP.Promise( getRetrievingProcessor.call( me, key, cur, options ) )
                    .then( function( value ){
                        return new RSVP.Promise( getPublisherProcessor.call( me, key, value, cur, options ) );
                    } );
            })(me, key, cur);
            promises.push( promise );
            
        }

        return RSVP.all( promises );
    };

    return Ctor;
});
